(function () {
  function initCardGalleries() {
    var galleries = document.querySelectorAll('[data-kv-card-gallery].has-multiple-images');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.galleryInitialized === 'true') return;
      gallery.dataset.galleryInitialized = 'true';

      var images = Array.from(gallery.querySelectorAll('.kv-shop-card-img'));
      var dots = Array.from(gallery.querySelectorAll('.kv-shop-gallery-dot'));
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');

      if (images.length <= 1) return;

      var currentIndex = 0;

      function goToImage(index) {
        currentIndex = (index + images.length) % images.length;

        images.forEach(function (img, i) {
          if (i === currentIndex) {
            img.classList.add('is-active');
          } else {
            img.classList.remove('is-active');
          }
        });

        dots.forEach(function (dot, i) {
          if (i === currentIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }

      var card = gallery.closest('.kv-shop-card') || gallery.closest('product-card') || gallery.closest('.product-card');
      if (card) {
        card.addEventListener('mouseenter', function () {
          if (!gallery.dataset.userNavigated && images.length > 1) {
            goToImage(1);
          }
        });

        card.addEventListener('mouseleave', function () {
          gallery.dataset.userNavigated = '';
          goToImage(0);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          gallery.dataset.userNavigated = 'true';
          goToImage(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          gallery.dataset.userNavigated = 'true';
          goToImage(currentIndex + 1);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          gallery.dataset.userNavigated = 'true';
          goToImage(i);
        });

        dot.addEventListener('mouseenter', function () {
          gallery.dataset.userNavigated = 'true';
          goToImage(i);
        });
      });

      // Touch swipe support for mobile
      var touchStartX = 0;
      var touchEndX = 0;

      gallery.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      gallery.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 35) {
          if (diff < 0) {
            goToImage(currentIndex + 1);
          } else {
            goToImage(currentIndex - 1);
          }
        }
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardGalleries);
  } else {
    initCardGalleries();
  }

  document.addEventListener('shopify:section:load', initCardGalleries);
  document.addEventListener('shopify:section:select', initCardGalleries);
})();
